export default "__VITE_PUBLIC_ASSET__331e4584__"